import React from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Brands from "@/pages/Brands";
import Locations from "@/pages/Locations";
import Floors from "@/pages/Floors";
import Categories from "@/pages/Categories";
import QrCodes from "@/pages/QrCodes";
import Offers from "@/pages/Offers";
import Vouchers from "@/pages/Vouchers";
import LoyaltyRules from "@/pages/LoyaltyRules";
import UsersPage from "@/pages/UsersPage";
import Customers from "@/pages/Customers";
import Bills from "@/pages/Bills";
import WhatsApp from "@/pages/WhatsApp";
import KarixSetup from "@/pages/KarixSetup";
import Reports from "@/pages/Reports";
import Analytics from "@/pages/Analytics";

function Protected() {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-[#8C8C8C]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/brands" element={<Brands />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/floors" element={<Floors />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/qrcodes" element={<QrCodes />} />
            <Route path="/offers" element={<Offers />} />
            <Route path="/vouchers" element={<Vouchers />} />
            <Route path="/loyalty" element={<LoyaltyRules />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/bills" element={<Bills />} />
            <Route path="/whatsapp" element={<WhatsApp />} />
            <Route path="/karix" element={<KarixSetup />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/analytics" element={<Analytics />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
